angular.module('picmonicng').directive('flagCard', [
  '$rootScope',
  '$q',
  function ($rootScope, $q) {
    return {
      restrict: 'A',
      scope: { card: '=' },
      link: function (scope, element, attrs) {
        scope.disabled = false;

        element.bind('click', function () {
          scope.$apply(function () {
            if (!scope.disabled) {
              if (scope.card.flag == 1) {
                scope.card.flag = 0;
              } else {
                scope.card.flag = 1;
              }

              scope.disabled = true;
              scope.card.$update().then(function () {
                $rootScope.$broadcast('playlistCardDataChanged', {
                  action: 'bookmarkCard',
                  card_id: scope.card.card_id,
                  playlist_id: 'bookmarked',
                  promise: $q.when([]),
                });
                scope.disabled = false;
              });
            }
          });
        });
      },
    };
  },
]);
